import { IAnalyticsAcntPage } from './adobe-analytics-model';
import { ACNT_APP_CONSTANT } from './adobe-acnt-constants';

export const ANALYTICS: { [key: string]: IAnalyticsAcntPage } = {
  Applicant_LandingPage: {
    id: 'Applicant_LandingPage',
    name: 'Applicant_Landing_Screen',
    applicationName: ACNT_APP_CONSTANT.app_name,
    applicationType: ACNT_APP_CONSTANT.app_type,
  },
  Applicant_Grant_DetailsPage: {
    id: 'Applicant_Grant_DetailsPage',
    name: 'Applicant_Grant_Details_Screen',
    applicationName: ACNT_APP_CONSTANT.app_name,
    applicationType: ACNT_APP_CONSTANT.app_type,
  },
  Applicant_New_Grant_Application_Page: {
    id: 'Applicant_New_Grant_Application_Page',
    name: 'Applicant_New_Grant_Application_Screen',
    applicationName: ACNT_APP_CONSTANT.app_name,
    applicationType: ACNT_APP_CONSTANT.app_type,
  },
  Applicant_Communication_PreferencesPage: {
    id: 'Applicant_Communication_Preferences_Page',
    name: 'Applicant_Communication_Preferences_Screen',
    applicationName: ACNT_APP_CONSTANT.app_name,
    applicationType: ACNT_APP_CONSTANT.app_type,
  },
  Applicant_Review_Submit_SummaryPage: {
    id: 'Applicant_Review_Submit_Summary_Page',
    name: 'Applicant_Review_Submit_Summary_Screen',
    applicationName: ACNT_APP_CONSTANT.app_name,
    applicationType: ACNT_APP_CONSTANT.app_type,
  },
  Applicant_Review_Submit_ConfirmationPage: {
    id: 'Applicant_Review_Submit_Confirmation_Page',
    name: 'Applicant_Review_Submit_Confirmation_Screen',
    applicationName: ACNT_APP_CONSTANT.app_name,
    applicationType: ACNT_APP_CONSTANT.app_type,
  },
  Applicant_Review_Grant_DetailsPage: {
    id: 'Applicant_Review_Grant_Details_Page',
    name: 'Applicant_Review_Grant_Details_Screen',
    applicationName: ACNT_APP_CONSTANT.app_name,
    applicationType: ACNT_APP_CONSTANT.app_type,
  },
  Applicant_Grant_Summary_DetailsPage: {
    id: 'Applicant_Grant_Summary_Details_Page',
    name: 'Applicant_Grant_Summary_Details_Screen',
    applicationName: ACNT_APP_CONSTANT.app_name,
    applicationType: ACNT_APP_CONSTANT.app_type,
  },
  Reviewer_DashboardPage: {
    id: 'Reviewer_Dashboard_Page',
    name: 'Reviewer_Dashboard_Screen',
    applicationName: ACNT_APP_CONSTANT.app_name,
    applicationType: ACNT_APP_CONSTANT.app_type,
  },
  Reviewer_Application_DetailsPage: {
    id: 'Reviewer_Application_Details_Page',
    name: 'Reviewer_Application_Details_Screen',
    applicationName: ACNT_APP_CONSTANT.app_name,
    applicationType: ACNT_APP_CONSTANT.app_type,
  },
  Admin_Finance_ReportsPage: {
    id: 'Admin_Finance_Reports_Page',
    name: 'Admin_Finance_Reports_Screen',
    applicationName: ACNT_APP_CONSTANT.app_name,
    applicationType: ACNT_APP_CONSTANT.app_type,
  },
};
